module.exports = __webpack_public_path__ + "img/arrow_up_square.aeefe02b.svg";